import React from 'react';
import { connect } from 'react-redux';
import { withCookies } from 'react-cookie';
import AddIcon from '@mui/icons-material/AddCircle';
import EditIcon from "@mui/icons-material/Create";
import TemplatesIcon from '@mui/icons-material/Email';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import { ListScreen } from '../components';
import { fetchMtoknaNewsletters, cleanMtoknaNewsletters, deleteMtoknaNewsletter, setUser, changeUserSetting } from '../actions';
import {__, formatDate, request, toNumber} from '../functions';
import { IMAGES } from '../config';
import '../assets/styles/mtokna_newsletters.css';
import DeleteIcon from "@mui/icons-material/Delete";
import _ from "lodash";

/**
 * Emaily.
 */
class MtoknaNewslettersScreen extends ListScreen {
    /**
     * Title.
     *
     * @type {string}
     */
    title = __('Newsletter');

    /**
     * Default state.
     *
     * @type {Object}
     */
    state = { ...ListScreen.state, ...{
        lightbox: {
            test: false,
            send: false,
            delete: false,
        },
    }};

    /**
     * Vratime zoznam tagov.
     *
     * @return {Array}
     */
    getTags() {
        const { user } = this.props;

        if (user.mtokna_moderator) {
            return [];
        }

        return [
            {
                name: __('Nový newsletter'),
                color: 'secondary',
                icon: <AddIcon />,
                onClick: () => this.redirect(`/newsletter/0`),
            },
        ];
    }

    /**
     * Vratime nazov tabulky.
     *
     * @return {string}
     */
    getTableName() {
        return 'mtokna_newsletters';
    }

    /**
     * Vratime empty text.
     *
     * @return {string}
     */
    getEmptyText() {
        return __('Zatiaľ nemáte žiadny newsletter');
    }

    /**
     * Vratime zoznam stlpcov.
     *
     * @return {Array}
     */
    getColumns() {
        return [
            <div>{__('ID')}</div>,
            <div>{__('Názov')}</div>,
            <div>{__('Predmet')}</div>,
            <div>{__('Odoslané')}</div>,
            <div>{__('Vytvorené')}</div>,
            <div></div>,
        ];
    }

    /**
     * Vratime bunky.
     *
     * @param {Object} item
     *
     * @return {Array}
     */
    getCells(item) {
        const { user } = this.props;

        return [
            <div>{item.id}</div>,
            <div>{_.truncate(item.name, { length: 64 })}</div>,
            <div>{_.truncate(item.subject, { length: 64 })}</div>,
            <div>{item.sent !== null ? formatDate(item.sent, 'dd.mm.yyyy hh:ii') : '-'}</div>,
            <div>{formatDate(item.created, 'dd.mm.yyyy')}</div>,
            <div>
                {this.renderTableButton(
                    item.id,
                    __('Test'),
                    <TemplatesIcon />,
                    (callbackLoading, callback) => this.confirmTest(item.id, callbackLoading, callback),
                    { disabled: user.mtokna_moderator }
                )}
                {this.renderTableButton(
                    item.id,
                    __('Odoslať MO predajcom'),
                    <MarkEmailReadIcon color="orange" />,
                    (callbackLoading, callback) => this.confirmSend(item.id, callbackLoading, callback),
                    { disabled: user.mtokna_moderator }
                )}
                {this.renderTableButton(
                    item.id,
                    __('Upraviť'),
                    <EditIcon />,
                    (callbackLoading, callback) => this.redirect(`/newsletter/${item.id}`),
                    {}
                )}
                {this.renderTableButton(
                    item.id,
                    __('Zmazať'),
                    <DeleteIcon />,
                    (callbackLoading, callback) => this.confirmDelete(item.id, callbackLoading, callback),
                    {}
                )}
            </div>,
        ];
    }

    confirmTest(id, callbackLoading, callback) {
        this.showLightbox('test', { id, callbackLoading, callback });
    }

    confirmSend(id, callbackLoading, callback) {
        this.showLightbox('send', { id, callbackLoading, callback });
    }

    confirmDelete(id, callbackLoading, callback) {
        this.showLightbox('delete', { id, callbackLoading, callback });
    }

    test() {
        const { lightbox } = this.state;

        // Zavolame loading
        lightbox.test.callbackLoading();

        // Zavrieme lightbox
        this.closeLightbox('test');

        request(`/mtokna/testNewsletter/${lightbox.test.id}`).then(response => {
            const { status } = response.data;

            lightbox.test.callback();

            if (status === 'error') {
                // Prihlasenie sa nepodarilo
                this.showSnackbar('error', __('Testovací email sa nepodarilo odoslať'));
                return;
            }

            this.showSnackbar('success', __('Testovací email bude v najbližšej dobe odoslaný'));
        });
    }

    send() {
        const { lightbox } = this.state;

        // Zavolame loading
        lightbox.send.callbackLoading();

        // Zavrieme lightbox
        this.closeLightbox('send');

        request(`/mtokna/sendNewsletter/${lightbox.send.id}`).then(response => {
            const { status } = response.data;

            lightbox.send.callback();

            if (status === 'error') {
                // Prihlasenie sa nepodarilo
                this.showSnackbar('error', __('Newsletter sa nepodarilo odoslať'));
                return;
            }

            this.showSnackbar('success', __('Newsletter bude v najbližšej dobe odoslaný'));

            setTimeout(function() { window.location = '/newsletters'; }, 500);
        });
    }

    async delete() {
        const { deleteMtoknaNewsletter, items } = this.props;
        const { lightbox } = this.state;

        // Zavolame loading
        lightbox.delete.callbackLoading();

        // Zavrieme lightbox
        this.closeLightbox('delete');

        // Zmazeme klienta
        await deleteMtoknaNewsletter(this, lightbox.delete.id);

        // Zavolame callback
        lightbox.delete.callback();

        // Znovu nacitame zoznam od prvej stranky
        this.fetchList(1, 0, items.filtered);
    }

    /**
     * Rendrujeme screen.
     *
     * @return {JSX.Element|null}
     */
    renderScreen() {
        const { items } = this.props;

        return (
            <div>
                {this.renderLightbox(
                    'test',
                    __('Naozaj chcete odoslať testovací email?'),
                    null,
                    __('Áno'),
                    __('Nie'),
                    () => this.test()
                )}
                {this.renderLightbox(
                    'send',
                    __('Naozaj chcete odoslať newsletter všetkým {COUNT} predajcom?').replace('{COUNT}', items.sellers),
                    null,
                    __('Áno'),
                    __('Nie'),
                    () => this.send()
                )}
                {this.renderLightbox(
                    'delete',
                    __('Naozaj chcete zmazať tento newsletter?'),
                    null,
                    __('Áno'),
                    __('Nie'),
                    () => this.delete()
                )}
                {this.renderSnackbar()}
            </div>
        );
    }
}

const stateToProps = ({ mtokna_newsletters, user }) => ({ items: mtokna_newsletters, user });

export default withCookies(connect(stateToProps, {
    fetch: fetchMtoknaNewsletters,
    clean: cleanMtoknaNewsletters,
    setUser,
    changeUserSetting,
    deleteMtoknaNewsletter,
})(MtoknaNewslettersScreen));
